export default {
  methods: {
    downloadFile(link, name) {
      let a = document.createElement('a')
      a.href = link
      a.target = '_blank'
      a.download = name
      document.body.append(a)
      a.click()
      a.remove()
    },
  },
}
